import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router';
import { strings } from '@singparty/shared';
import { useRealtime } from '@/hooks/useRealtime';
import { useConnStatus } from '@/stores/sessionStore';
import { Button } from '@/components/ui/Button';

/**
 * Guest session layout — owns the single WebSocket for the whole guest visit
 * so navigating Home ↔ Add doesn't reconnect. Children read from the store.
 */
export const Route = createFileRoute('/s/$sid')({
  component: GuestLayout,
});

function GuestLayout() {
  const { sid } = Route.useParams();
  const navigate = useNavigate();
  useRealtime(sid);
  const status = useConnStatus();

  if (status === 'ended') {
    return (
      <div className="flex min-h-full flex-col items-center justify-center px-6 text-center">
        <h1 className="mb-2 text-3xl font-extrabold">{strings.guestHome.endedTitle}</h1>
        <p className="mb-8 text-text-secondary">Hope you had a blast.</p>
        <Button onClick={() => navigate({ to: '/join' })}>{strings.guestHome.endedJoinAnother}</Button>
      </div>
    );
  }

  // The connection pill lives on the guest Home page only — on the Add page it
  // overlaps the search input (it's a fixed top-center badge).
  return <Outlet />;
}
